export default __webpack_public_path__ + "static/media/arrow-btn-right.633503be.svg";